import BaseService from './base'

export default class SettingService extends BaseService {
  static resource() {
    return 'api/v1/settings'
  }
}
